<template>
    <a-upload
        accept="image/*"
        list-type="picture-card"
        v-model:fileList="fileList"
        :beforeUpload="beforeUpload"
        :max-count="max"
        @preview="preview"
        @change="onFileChange"
    >
        <div v-if="fileList.length < 8">
            <PlusOutlined />
            <div class="ant-upload-text">Upload</div>
        </div>
        <div v-for="(file, index) in fileList" :key="index">
            <slot name="imageRender" :file="file"></slot>
        </div>
    </a-upload>
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, h, } from 'vue';

import { Upload, Modal, UploadFile, UploadChangeParam } from 'ant-design-vue';
import {
    PlusOutlined,
} from '@ant-design/icons-vue';

import { getFileDataBase64 } from '@/utils/helpers';
import { uploadImgur } from '@/utils/HttpRequest';

type UploadImageFile = UploadFile;

export default defineComponent({
    props: {
        defaultImages: Array<string>,
        onChange: Function,
        max: Number,
    },

    components: {
        AUpload: Upload,

        PlusOutlined,
    },

    setup(props) {
        const fileList = ref<UploadImageFile[]>([]);
        const previewImg = ref<UploadImageFile>({
            uid: '-1',
            name: '',
        });

        onMounted(() => {
            const images = props.defaultImages;
            if (images && (images.length > 0)) {
                fileList.value = images.map(image => ({
                    uid: image,
                    name: image,
                    status: 'done',
                    url: image,
                }));
            }
        });

        const beforeUpload = (file: UploadFile) => {
            fileList.value.push(file);

            return false;
        };

        const preview = async (file: UploadImageFile) => {
            if (!file.url && !file.preview) {
                file.preview = await getFileDataBase64(file.originFileObj) as string;
            }

            Modal.info({
                title: file.name,
                content: h(
                    'img',
                    {
                        style: { width: '100%' },
                        src: file.url || file.preview,
                    },
                ),
                maskClosable: true,
            });
        };

        const onFileChange = (ev: UploadChangeParam<UploadFile>) => {
            const { file } = ev;

            if (!file || file.url || file.originFileObj || !(file instanceof File)) {
                return;
            }

            const fileItem = fileList.value.find((v) => {
                return v.uid === file.uid;
            });

            if (!fileItem) {
                file.status = 'error';
                return;
            }

            fileItem.status = 'uploading';
            uploadImgur(file, (pe) => {
                if (fileItem) {
                    fileItem.percent = (pe.progress || (pe.loaded / (pe.total || pe.loaded))) * 100;
                }
            })
                .then(res => {
                    const resData = res.data;
                    fileItem.url = resData.data.link;
                    fileItem.name = fileItem.url as string;
                    fileItem.status = 'done';

                    if (props.onChange) {
                        props.onChange(fileItem);
                    }
                })
                .catch(() => {
                    fileItem.status = 'error';
                });
        };

        return {
            fileList,
            previewImg,

            beforeUpload,
            preview,
            onFileChange,
        };
    },
});
</script>
